var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgWarning64 = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 64,
  height: 64,
  fill: "none",
  viewBox: "0 0 64 64",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M33.495 15.728a1.5 1.5 0 0 0-2.573 0l-18.701 31.17a1.5 1.5 0 0 0 1.286 2.271H50.91a1.5 1.5 0 0 0 1.286-2.272zm-5.145-1.543c1.747-2.913 5.97-2.913 7.717 0L54.77 45.354c1.8 3-.361 6.815-3.86 6.815H13.508c-3.498 0-5.658-3.816-3.859-6.815zM32 23.5a1.5 1.5 0 0 1 1.5 1.5v11a1.5 1.5 0 0 1-3 0V25a1.5 1.5 0 0 1 1.5-1.5m17.21-2.637a1.5 1.5 0 0 0-2.585 1.523l4.582 7.78a1.5 1.5 0 0 0 2.585-1.523zm-28.223-6.145a1.5 1.5 0 0 1 .504 2.06l-7 11.534a1.5 1.5 0 1 1-2.565-1.556l7-11.534a1.5 1.5 0 0 1 2.06-.504m12.72 28.199a1.5 1.5 0 0 0-3 0v.24a1.5 1.5 0 0 0 3 0z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarning64);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };